import { Injectable, inject } from '@angular/core';
import type { Observable } from 'rxjs';
import { ApiService } from '@core/http/api.service';
import type { UserPreferences } from './user-preferences.types';

/**
 * DTO complet des préférences user exposé via `GET /admin/users/:userId/preferences`.
 * Comme l'admin n'écrit jamais ces champs, on duplique le type complet (incluant
 * `profileVisibility` et `allowMessaging` rendus en lecture seule).
 */
export interface AdminUserPreferences extends UserPreferences {
  profileVisibility: string;
  allowMessaging: string;
}

/**
 * Matrice 4x3 des préférences notifications. Le DTO backend mirror le contrat
 * `NotificationPreferencesResponseDto` côté webapp.
 */
export interface AdminUserNotificationPreferences {
  transactionalPush: boolean;
  transactionalEmail: boolean;
  transactionalSms: boolean;
  socialPush: boolean;
  socialEmail: boolean;
  socialSms: boolean;
  livePush: boolean;
  liveEmail: boolean;
  liveSms: boolean;
  marketingPush: boolean;
  marketingEmail: boolean;
  marketingSms: boolean;
}

/**
 * Client HTTP admin pour la lecture des préférences d'un user tiers (read-only).
 *
 * Endpoints (read-only, admin support use case) :
 *   GET /admin/users/:userId/preferences               → AdminUserPreferences
 *   GET /admin/users/:userId/notification-preferences  → AdminUserNotificationPreferences
 */
@Injectable({ providedIn: 'root' })
export class AdminUserPreferencesApiService {
  private readonly api = inject(ApiService);

  getUserPreferences(userId: string): Observable<AdminUserPreferences> {
    return this.api.get<AdminUserPreferences>(`/admin/users/${userId}/preferences`);
  }

  getUserNotificationPreferences(userId: string): Observable<AdminUserNotificationPreferences> {
    return this.api.get<AdminUserNotificationPreferences>(
      `/admin/users/${userId}/notification-preferences`
    );
  }
}
